import { get, post, postFile, put, deleteById } from './api';

export const allergiesAPI = {
  getAllergies() {
    return get('admin/allergy');
  },

  addAllergy(allergyData) {
    return post('admin/allergy', allergyData);
  },

  updateAllergy(allergyData) {
    return put('admin/allergy', allergyData);
  },

  deleteAllergy(id) {
    return deleteById('admin/allergy', id);
  },

  importAllergies(importData) {
    return postFile('admin/allergies/import', importData);
  },

  addAllergyIngredient(ingredientData) {
    return post('admin/allergy/ingredient', ingredientData);
  },

  deleteAllergyIngredient(ingredientData) {
    return put('admin/allergy/ingredient/delete', ingredientData);
  },
};
